
import './ProfileHeader.scss';
import playwatchlogo from 'assets/images/playwatch.svg';
import LinearIndeterminate from './LinearIndeterminate';
import { useSelector } from 'react-redux';
import { is_profile_busy } from 'features/profile/profile-slice';
import { CircularProgress } from '@mui/material';
export default function ProfileHeader(props: any) {
    const profile_busy = useSelector(is_profile_busy);

    return (
        <>
            <div style={{ bottom: 0, position: 'absolute', width: `100vw` }}>
                <LinearIndeterminate visible={profile_busy} />
            </div>
            <nav className="sc-jzgbtB cQRKZt sc-gJWqzi iuMSCZ ">
                <div className="sc-cHGsZl gSVDmn" aria-label="logo" title="logo" role="img" id="logo" placeholder="logo" tabIndex={0}
                    style={{ height: 48, marginRight: 'auto', width: 'auto' }}>
                    <div className="logo container--hw-full " style={{
                        backgroundImage: `url(${playwatchlogo})`,
                        minWidth: 100
                    }}>
                    </div>
                </div>
                {profile_busy ? <><CircularProgress size={'4rem'} /></> : <button aria-label="Edit Profiles" data-testid="edit-profiles-button" role="button" kind="secondary"
                    className="sc-cvbbAY dhKEIN button button--secondary "
                    onClick={() => {
                        if (props.onBtnClick) {
                            props.onBtnClick();
                        }
                    }} data-gv2elementkey="editProfileButton"
                    data-gv2interactionkey="editProfileButton" data-gv2-interaction-bound="true">{props.btnTitle}</button>}
            </nav>
        </>

    );
}